import { memo, useEffect } from 'react';

const ChangeTheme = ({ webConfiguration: { theme } }) => {
    useEffect(() => {
        document.body.setAttribute('data-theme', theme);
    }, [theme]);
    return null;
};

export default memo(ChangeTheme);
